<h2>HEENT</h2>
<h2>Head</h2>
<assessment-row title="Abnormal Shape">
    <p>{{ data.headAbnormalShape }}</p>
</assessment-row>
<assessment-row title="Lesions or Scars">
    <p>{{ data.headLesionsOrScars }}</p>
</assessment-row>
<assessment-row title="Other">
    <p>{{ data.headOther }}</p>
</assessment-row>
<h2>Eyes</h2>
<assessment-row title="Pupillary Response">
    <p>{{ data.pupillaryResponse }}</p>
</assessment-row>
<assessment-row title="Left Pupillary Dilation">
    <p>{{ data.leftPupillaryDilation }}</p>
</assessment-row>
<assessment-row title="Right Pupillary Dilation">
    <p>{{ data.rightPupillaryDilation }}</p>
</assessment-row>
<assessment-row title="Sclera Yellow">
    <p>{{ isScleraYellow }}</p>
</assessment-row>
<assessment-row title="Conjunctiva Pale">
    <p>{{ isConjunctivaPale }}</p>
</assessment-row>
<assessment-row title="Conjunctiva Red">
    <p>{{ isConjunctivaRed }}</p>
</assessment-row>
<assessment-row title="Other">
    <p>{{ data.eyesOther }}</p>
</assessment-row>
<h2>Ears</h2>
<assessment-row title="Asymmetrical">
    <p>{{ isAsymmetrical }}</p>
</assessment-row>
<assessment-row title="Hearing Impaired">
    <p>{{ data.hearingImpaired }}</p>
</assessment-row>
@if (data.hearingImpaired != 'WNL') {
<assessment-row title="Hearing Aid Left">
    <p>{{ isHearingAidLeft }}</p>
</assessment-row>
<assessment-row title="Hearing Aid Right">
    <p>{{ isHearingAidRight }}</p>
</assessment-row>
}
<assessment-row title="Ears Discharge Present">
    <p>{{ data.earsDischargePresent }}</p>
</assessment-row>
<assessment-row title="Other">
    <p>{{ data.earsOther }}</p>
</assessment-row>
<h2>Nose</h2>
<assessment-row title="Obstructed Nares">
    <p>{{ data.obstructedNares }}</p>
</assessment-row>
<assessment-row title="Nose Discharge Present">
    <p>{{ data.noseDischargePresent }}</p>
</assessment-row>
<h2>Neck</h2>
<assessment-row title="Firm to Touch">
    <p>{{ data.neckFirmToTouch }}</p>
</assessment-row>
<assessment-row title="Stiff Neck">
    <p>{{ data.stiffNeck }}</p>
</assessment-row>
<assessment-row title="Enlarged Lymph Nodes">
    <p>{{ data.enlargedLymphNodes }}</p>
</assessment-row>
<assessment-row title="Deviated Trachea">
    <p>{{ data.deviatedTrachea }}</p>
</assessment-row>
<h2>Throat/Mouth</h2>
<assessment-row title="Dry Mucus Membranes">
    <p>{{ hasDryMucusMembranes }}</p>
</assessment-row>
<assessment-row title="Lesions Present">
    <p>{{ data.throatLesionsPresent }}</p>
</assessment-row>
<assessment-row title="Enlarged Tonsils">
    <p>{{ data.enlargedTonsils }}</p>
</assessment-row>